import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { Checkout, StateInfoBox } from "@/components";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, type StripeElementsOptions } from "@stripe/stripe-js";
import { useAmlCheckStore, usePaymentStore, useUserStore } from "@/store";
import { PAGES } from "@/config";

const stripePromise = loadStripe(
  import.meta.env.VITE_REACT_APP_STRIPE_PUBLIC_KEY!,
);

const Home = () => {
  const navigate = useNavigate();
  const clientSecret = usePaymentStore(
    (state) => state.paymentIntent?.clientSecret,
  );
  const { initPaymentIntent } = usePaymentStore();
  const balance = useUserStore((state) => state.user.balance);
  const { hasAmlInputs } = useAmlCheckStore();
  const initialized = useRef(false);

  useEffect(() => {
    if (!hasAmlInputs) {
      navigate(PAGES.AML_HISTORY);
      return;
    }

    if (balance > 0) {
      navigate(PAGES.AML_CHECK);
      return;
    }

    if (!clientSecret && !initialized.current) {
      initialized.current = true;
      initPaymentIntent();
    }
  }, [hasAmlInputs, balance, clientSecret, navigate, initPaymentIntent]);

  if (!clientSecret) {
    return <StateInfoBox type="loading" title="Processing..." />;
  }

  const options: StripeElementsOptions = {
    clientSecret: clientSecret,
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <Checkout />
    </Elements>
  );
};

export default Home;
